import { Component, Input } from '@angular/core';
import { AngularNodeViewComponent } from 'ngx-tiptap';
import { SuggestionProps } from '@tiptap/suggestion';

@Component({
  selector: 'app-mentions-list',
  templateUrl: './mentions.html',
  styleUrls: ['./mentions.scss'],
  imports: [],
  standalone: true
})
/**
 * Helferklasse zum Manövrieren durch die Mentions-Liste im TipTap-Editor
 * Erfüllt die AFO: A_25437 - Erwähnungen im Chat
 */
export class MentionsList extends AngularNodeViewComponent {
  @Input() props!: MentionSuggestionProps;

  selectedIndex = 0;

  upHandler(): void {
    this.selectedIndex = (this.selectedIndex + this.props['items'].length - 1) % this.props['items'].length;
  }

  downHandler(): void {
    this.selectedIndex = (this.selectedIndex + 1) % this.props['items'].length;
  }

  enterHandler(): void {
    this.selectItem(this.selectedIndex);
  }

  selectItem(index: number): void {
    const item = this.props['items'][index];

    if (item) {
      this.props['command']({
        avatar: item.avatar,
        displayname: item.displayname,
        id: item.id,
        link: item.link,
        target: item.target,
        value: item.value
      });
    }
  }

  onKeyDown(event: KeyboardEvent): boolean {
    if (event.key === 'ArrowUp') {
      this.upHandler();
      return true;
    }

    if (event.key === 'ArrowDown') {
      this.downHandler();
      return true;
    }

    if (event.key === 'Enter') {
      this.enterHandler();
      return true;
    }

    return false;
  }
}

export type MentionSuggestionProps = SuggestionProps<{
  id: string;
  value: string;
  displayname: string;
  avatar?: string;
  link?: string;
  target?: string;
}>;
